
import Vue from "vue";
import Component from "vue-class-component";
import NavBar from "@/components/NavBar";

@Component({
  components: {
    NavBar
  }
})
export default class FaqPage extends Vue {
  get faqs() {
    return this.$t("faq.faqs");
  }
}
